import { useEffect, useState } from 'react';
import { parseAsString, useQueryState } from 'nuqs';
import { SearchBox } from '@johnlewispartnership/wtr-ingredients/dist/ingredients/SearchBox';
import { navigateTo } from 'renderer/utils/navigate';
import { RECIPE_QUERY_SEARCH_TERM, RECIPE_SEARCH_ID, RECIPE_SEARCH_PATH } from '../constants';

const RecipeSearchBar = () => {
  const [searchTerm, setSearchTerm] = useQueryState(
    RECIPE_QUERY_SEARCH_TERM,
    parseAsString.withDefault(''),
  );
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    setInputValue(searchTerm);
  }, [searchTerm]);

  const handleSubmit = () => {
    if (window.location.pathname === RECIPE_SEARCH_PATH) {
      setSearchTerm(inputValue);
    } else {
      navigateTo(
        `${RECIPE_SEARCH_PATH}?${RECIPE_QUERY_SEARCH_TERM}=${encodeURIComponent(inputValue)}`,
      );
    }
  };

  return (
    <SearchBox
      ariaTitle="Recipes"
      id={RECIPE_SEARCH_ID}
      value={inputValue}
      placeholder="Search by recipe or ingredient..."
      onChange={e => setInputValue(e.target.value)}
      onSubmit={handleSubmit}
      onClearClick={() => {
        setInputValue('');
      }}
    />
  );
};

export default RecipeSearchBar;
